export default __webpack_public_path__ + "static/4_35-e36309971b3a5b8517ecf05294b7cf3d.png";